module.exports = __webpack_public_path__ + "static/media/FullFolder.68f88dce.svg";